
import { repository } from 'src/jtech/jtech-repository'

export const ServiceRequestRepository = {

  nmInterfaceConsumerUnitAttachmentPesquisarConsumerUnit: 'consumerUnitFile.pesquisarConsumerUnit',
  nmInterfaceConsumerUnitAttachmentGravar: 'consumerUnitFile.gravar',
  nmInterfaceConsumerUnitAttachmentAlterar: 'consumerUnitFile.alterar',

  loadDatatable: async function () {
    return await repository.resolveDatatable(this.nmInterfaceConsumerUnitAttachmentPesquisarConsumerUnit)
  },

  async loadDatatableModel (params) {
    return await repository.resolveDatatableModel(this.nmInterfaceConsumerUnitAttachmentPesquisarConsumerUnit, { ...params })
  },

  async loadForm () {
    return await repository.resolve(this.nmInterfaceConsumerUnitAttachmentGravar)
  },

  async loadFormAlterar (params) {
    return await repository.resolveForm(this.nmInterfaceConsumerUnitAttachmentAlterar, params)
  },

  async createUnitAttachment (params) {
    return await repository.create(this.nmInterfaceConsumerUnitAttachmentGravar, { ...params })
  },

  async downloadFile (filePath, nmIdentificacaoParserFile) {
    return await repository.downloadFile(
      filePath,
      null,
      nmIdentificacaoParserFile
    )
  }
}
